import React, { useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import classnames from "classnames";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// Keeping original component & file references intact
import AcknowledgementLetter from "./AcknowledgementLetter";
import BonafideLetter from "./BonafideLetter";
import AdmissionCard from "./AdmissionCard";
import NoObjectionCertificate from "./NoObjectionCertificate";
import AdmissionLetter from "./AdmissionLetter";
import FeeStructureLetter from "./FeeStructureLetter";
import DemandLetter from "./DemandLetter";
import PermissionCard from "./PermissionCard";

const LettersComponent = () => {
  const auth = useSelector((state) => state.authentication);
  const { branchData } = auth;
  const { studentId } = useParams();
  const location = useLocation();
  const student = location.state?.student;

  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Container className="mt-4">
      <h5 className="mb-3">
        Document Management for:{" "}
        <span className="text-primary">{student?.name || student?.vendorName || "Account Record"}</span>
      </h5>

      {/* TABS WITH CORPORATE DISPLAY LABELS */}
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => toggle("1")}
            style={{ cursor: "pointer" }}
          >
            Project Cost Estimate
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => toggle("2")}
            style={{ cursor: "pointer" }}
          >
            Onboarding Agreement
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "3" })}
            onClick={() => toggle("3")}
            style={{ cursor: "pointer" }}
          >
            Receipt Acknowledgement
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "4" })}
            onClick={() => toggle("4")}
            style={{ cursor: "pointer" }}
          >
            Vendor Verification
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "5" })}
            onClick={() => toggle("5")}
            style={{ cursor: "pointer" }}
          >
            Vendor Access Pass
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "6" })}
            onClick={() => toggle("6")}
            style={{ cursor: "pointer" }}
          >
            No Objection Certificate
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "7" })}
            onClick={() => toggle("7")}
            style={{ cursor: "pointer" }}
          >
            Payment Demand Note
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "8" })}
            onClick={() => toggle("8")}
            style={{ cursor: "pointer" }}
          >
            Operational Permit
          </NavLink>
        </NavItem>
      </Nav>

      {/* TAB CONTENT CALLING ORIGINAL COMPONENTS */}
      <TabContent activeTab={activeTab} className="p-3 border border-top-0 bg-white">
        <TabPane tabId="1">
          <FeeStructureLetter student={student} />
        </TabPane>
        <TabPane tabId="2">
          <AdmissionLetter student={student} />
        </TabPane>
        <TabPane tabId="3">
          <AcknowledgementLetter student={student} />
        </TabPane>
        <TabPane tabId="4">
          <BonafideLetter student={student} />
        </TabPane>
        <TabPane tabId="5">
          <AdmissionCard student={student} branchData={branchData} />
        </TabPane>
        <TabPane tabId="6">
          <NoObjectionCertificate student={student} branchData={branchData} />
        </TabPane>
        <TabPane tabId="7">
          <DemandLetter student={student} />
        </TabPane>
        <TabPane tabId="8">
          <PermissionCard student={student} branchData={branchData} />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default LettersComponent;